import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { setAlert } from '../../../actions/alert';
import { crearServicioConfiguracion } from '../../../actions/configuracion';

const NuevoServicio = ({ servicio, reestablecerServicio }) => {

    const dispatch =  useDispatch();

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [servicioData, setServicioData] = useState({
        nombre: null
    });

    /* Crear servicio */
    const handleInputChange = ({ target }) => {
        setServicioData({
            ...servicioData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(servicioData.nombre){
            await setStatusProcesar(true);
            await dispatch(crearServicioConfiguracion(servicioData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setServicioData({
                nombre: null
            });
            setNuevoModal(false);
            reestablecerServicio(null);
        }
    }

    useEffect(() => {
        if(servicio){
            setNuevoModal(true);

            setServicioData({
                ...servicioData
            });
        }        
    }, [servicio]);

    return (
        <Modal show={nuevoModal} size="md" backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Agregar servicio</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={servicioData.nombre} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="nombre">Nombre</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Agregar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Agregar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default NuevoServicio;